var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1561 2.3108C11.6424 1.8964 12.3576 1.8964 12.8439 2.3108L14.8659 4.03398C15.0743 4.21156 15.3334 4.31888 15.6063 4.34065L18.2546 4.55199C18.8915 4.60281 19.3972 5.10854 19.448 5.74541L19.6593 8.39369C19.6811 8.6666 19.7884 8.92569 19.966 9.13407L21.6892 11.1561C22.1036 11.6424 22.1036 12.3576 21.6892 12.8439L19.966 14.8659C19.7884 15.0743 19.6811 15.3334 19.6593 15.6063L19.448 18.2546C19.3972 18.8915 18.8915 19.3972 18.2546 19.448L15.6063 19.6593C15.3334 19.6811 15.0743 19.7884 14.8659 19.966L12.8439 21.6892C12.3576 22.1036 11.6424 22.1036 11.1561 21.6892L9.13407 19.966C8.92569 19.7884 8.6666 19.6811 8.39369 19.6593L5.74541 19.448C5.10854 19.3972 4.60281 18.8915 4.55199 18.2546L4.34065 15.6063C4.31888 15.3334 4.21156 15.0743 4.03398 14.8659L2.3108 12.8439C1.8964 12.3576 1.8964 11.6424 2.3108 11.1561L4.03398 9.13407C4.21156 8.92569 4.31888 8.6666 4.34065 8.39369L4.55199 5.74541C4.60281 5.10854 5.10854 4.60281 5.74541 4.55199L8.39369 4.34065C8.6666 4.31888 8.92569 4.21156 9.13407 4.03398L11.1561 2.3108Z",
    fill: "#A3B0B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39844 11.7075L10.5652 14L15.5984 10",
    stroke: "url(#paint0_radial_3633_3698)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3633_3698",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4277 8.9553) rotate(90) scale(5.74619 7.2549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#F5F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E4E4E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.57c39de3bf36955f969938a50f698464.svg";
export { ForwardRef as ReactComponent };